// https://github.com/angular/components/issues/24026
// https://www.devxperiences.com/pzwp1/2024/01/29/angular-material-datetimepickers-challenges/
import { LOCALE_ID, Provider } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { enGB, fr } from 'date-fns/locale'

// This provider creates instance of MAT_DATE_LOCALE, needed for date inputs and MatDatepicker
// Must be overridden according to https://material.angular.dev/components/datepicker/overview#setting-the-locale-code
export const LOCALIZED_MAT_DATE_LOCALE_PROVIDER: Provider = {
    provide: MAT_DATE_LOCALE,
    deps: [LOCALE_ID],
    useFactory:  (matDateLocale: string) => {
        switch (matDateLocale) {
            case 'fr': {
                return fr;
            }
            default: {
                return enGB;
            }
        }
    }
};